//Componentes generales
import { useEffect, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import { PRINCIPAL, NAVBARS,COLOR_BOTONES} from '../../constants/colors';

//Contextos
import tareaContext from '../../context/tareaContext/tareaContex';
import documentoContext from '../../context/documentosContext/documentosContex';
import DocumentoState from '../../context/documentosContext/documentosState';
import './FormDocumento.css';
import { estructuraDocumento } from '../../utils/estructuras';

/*
    Componente encargado de mostrar el formulario de Documento.
    Donde data es el documento recibido a modificar, con el cual se modelara documento.
    minimizar es la función encargada de ocultar el Form.
    generar es la función del context que guarda el usuario.
    titulo es la que determina que texto mostrar en encabezado del dialogo.
    documento es el estado que maneja la informacion a actualizar, añadir o eliminar.
*/
function FormDocumento({data,setData, minimizar, nuevoEditado, formDato, handleChangeDocumentos, index, generar = () => console.log("Generando"), listaUsuarios = [] }) {
    
    const dContext = useContext(documentoContext)
    const {agregarDocumento, modificarDocumento, eliminarDocumento} = dContext;

    //State de usuario. Si no viene data por parametro significa que es nuevo por lo que se le asigna una estructura.
    const [documento, setDocumento] = useState({codDocumento:"",name: ''});
    
    //Constante que define el titulo que corresponde si vienen datos por parametros
    //const titulo = (data?.id === "" || data?.id ===  undefined) ? 'Agregar' : 'Modificar';
    const [titulo, setTitulo] = useState(nuevoEditado);

    //Funcion de validacion
    const validacion =  () => { 
        const newErrors = {};
        if (documento.codDocumento === '' || documento.codDocumento === undefined) return newErrors.codigo = 'El código de documento debe ser colocado'
        if (documento.name === '' || documento.codDocumento === undefined) return newErrors.nombre = 'El nombre debe ser colocado'
        return '';
    };

    const handlerGenerar = async ()  => {
        const errorAxi = validacion();
        if ( errorAxi === "" ) {
            try {
                const dato = documento;
                const res = await agregarDocumento(dato);
                if (res.codDocumento !== undefined) {
                    Swal.fire({
                        title: `Se guardo un nuevo documento`,
                        icon: 'success',
                        text: `Código: ${res.codDocumento} \n Nombre: ${res.name}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    minimizar();
                } else if(res.code == 'DUPLICATEKEY') {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre del documento",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }  
    }

    const handlerModificar = async () => {

        const errorAxi = validacion();

        console.log("handlerModificar");
        

        if (errorAxi === "") {
    
            try {
                const dato = {
                    id: documento.id,
                    codDocumento: documento.codDocumento,
                    name: documento.name,
                    fecMod: documento.fecMod,
                    fecAlt: documento.fecAlt
                }
                console.log("dato en handlerModificar 96 FormDocumento");
                console.log(dato);
                
                const res = await modificarDocumento(dato);
                if(res.codDocumento != undefined){
                    Swal.fire({
                        title: `Se modificó el documento`,
                        icon: 'success',
                        text: `Nombre: ${res.name}\n Código: ${res.codDocumento}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    //Modela el dato para que siga el formato de los seleccionados por primera vez y para que se pueda modificar sin seleccionarlo nuevamente.
                    let datoModelado = {id:res._id,label:res.name,value:res.codDocumento,fecMod:res.fecMod,fecAlt:res.fecAlt};
                    await setData(datoModelado);
                    handleChangeDocumentos({},index,'documento',datoModelado);
                    minimizar();
                }
                else if(res.response.data.message != undefined){
                    if(res.response.data.message == 'El registro ha sido modificado desde otra sesión. Los cambios NO se guardarán'){
                        Swal.fire({
                            title:  "Se modificó el documento desde otra sesion, actualice pestaña e intentelo nuevamente.",
                            icon: 'warning',
                            showConfirmButton: true,
                            allowEnterKey: true
                        });
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }  
    }

    const handlerEliminar = () => {
        Swal.fire({
            title: `Estas seguro que deseas eliminar esta documento?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true, // Habilita el botón de cancelar
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true
        }).then(async (result) => {
            if (result.isConfirmed) {
                // El usuario hizo clic en "Aceptar"
                const id = documento.id
                const resp = await eliminarDocumento(id);

                if(resp){
                    Swal.fire({
                        title: `Borrado!`,
                        icon: 'success',
                        text: `El documento fue borrado correctamente!`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    handleChangeDocumentos({},index,'documento',{value:'',label:''});
                } 
                
                minimizar(null);
            } else if (result.isDismissed) {
                // El usuario hizo clic en "Cancelar" o en cualquier otro lugar fuera del diálogo
                minimizar();
            }
        });
    }

    useEffect(()=>{
        if(data !== undefined){
            //Se crea codigoTarea ya que habia diferencias en el nombre de la propiedad cuando llegaba desde editarProcedimiento que cuando se agregaba una documento nueva y se editaba.
            let docModelado = {id:data?.id, codDocumento: data.value, name: data?.label, fecMod:data?.fecMod, fecAlt:data?.fecAlt};
            setDocumento(docModelado);
        }
    },[data]);

    return (
        <div className='container-group-form'>
            <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}}>
                {titulo} documento
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Codigo de documento: </div>
                <input disabled={ titulo === "Modificar"} value={documento.codDocumento} className='label-form-group-data' onChange={data => setDocumento({ ...documento, ['codDocumento']:data.target.value })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nombre: </div>
                <input value={documento.name} className='label-form-group-data' onChange={data => setDocumento({ ...documento, ['name']: data.target.value })} />
            </div>

            <div className='container-btn-group'>
                <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} onClick={( titulo !== "Modificar") ? handlerGenerar : handlerModificar}>{titulo}</button> 
                {
                    (data !== "") &&(
                        <button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>
                    )
                }
                {
                    titulo === "Modificar" ? (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
                    ) : (
                        <button className='btn-cancel-form-group' onClick={() => minimizar()}>Cancelar</button>
                    )
                }
            </div>
        </div>
    );
}

export default FormDocumento;